export const isValidURL = (text: string): boolean => {
  try {
    new URL(text);
    return true;
  } catch (error) {
    return false;
  }
};
